// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore
import { MainStore } from '../stores/MainStore';

import { Link } from 'react-router-dom';

// Components
import CKeditor from 'ckeditor4-react';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

interface State {
  animal: any;
  animals: any;
  date: string;
  description: any;
  descriptionUpdated: any;
  errors: Array<any>;
  product: any;
  users: any;
  products: any;
  employee: any;
  files: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  filesOnServer: any;
  isFinished: boolean;
  isUpdating: boolean;
  name: any;
  toLocation: any;
  toDate: Date | null;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class BreedProfile extends React.Component<Props, State> {

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      animal: 0,
      animals: [],
      date: this.formatDate(new Date()),
      description: "",
      descriptionUpdated: "",
      employee: "",
      errors: [],
      files: "",
      filesOnServer: [],
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      name: "",
      product: "",
      products: [],
      toDate: null,
      toLocation: "",
      users: []
    };
  }

  async componentWillMount() {
    await NetworkManager.request(`animal`, MethodRequest_e.GET).then((result) => {
      this.setState({
        animals: result
      });
    });
    if (this.state.isUpdating) {
      await NetworkManager.request(`breed/details/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
        this.setState({
          filesOnServer: Object.values(result.pictures)
        });
      });
      await NetworkManager.request(`breed/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
        this.setState({
          animal: result.animal,
          description: result.description,
          descriptionUpdated: result.description,
          name: result.name
        });
      });
    }
  }

  handleChangeAnimal = () => {
    return (event: React.ChangeEvent<any>) => {
      this.setState({ animal: event.target.value });
    };
  }

  formatDate = (date: any) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1).toString();
    let day = '' + d.getDate().toString();
    const year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    return [year, month, day].join('-');
}

  handleChange = (name = "") => {
    return (event: React.ChangeEvent<any>) => {
      const key = name != "" ? name : event.target.name;
      this.setState({ [key]: event.target.value } as any);
    };
  }

  handleChangeSelect = (name: string): any => (value: string) => {
    this.setState({
      [name]: value
    } as any);
  }

  handleChangeCheck = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.checked } as any);
    };
  }

  handleFromDateChange = (date: Date) => {
    this.setState({ fromDate: date });
  }

  handleToDateChange = (date: Date) => {
    this.setState({ toDate: date });
  }

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
      const errors: any = [];

      if (this.state.name == "") {
        errors['name'] = "Ajouter un nom";
      }
      if (this.state.animal == "") {
        errors['animal'] = "Ajouter un animal";
      }
      if (this.state.descriptionUpdated == "") {
        errors['description'] = "Ajouter une description";
      }

      this.setState({ errors: errors });

      const errorsNumber = Object.keys(errors).length;

      if (errorsNumber == 0) {
        MainStore.showOverlay(`${this.state.isUpdating ? "Modification" : "Création"} de la race en cours...`);
        try {
          await NetworkManager.request(
            `breed${this.state.isUpdating ? `/${this.props.match.params.id}` : ""}`,
            this.state.isUpdating ? MethodRequest_e.PUT : MethodRequest_e.POST, {
              animal: this.state.animal,
              description: this.state.descriptionUpdated,
              name: this.state.name
            }).then((response) => {
              MainStore.showNotification(response.text);
              MainStore.goBack(this.props.history.location.pathname);
              this.props.history.goBack();
            });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
      }
    };
  }

  deletePicture = (item: any) => {
    return async (event: React.MouseEvent<any>) => {
      NetworkManager.request(`breed/upload/${this.props.match.params.id}`, MethodRequest_e.DELETE, {
      filename: item});
      const array = [...this.state.filesOnServer]; // make a separate copy of the array
      const index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
        this.setState({filesOnServer: array});
      }
    };
  }

  updateCkEditor = ( CKEDITOR: any ) => ( CKEDITOR.disableAutoInline = true );

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const id = this.props.match.params.id;
    return (
      <Paper elevation={1} className="form-paper-container">
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          {this.state.isUpdating ? "Modification" : "Création"} d'une race</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              label="Titre"
              name="name"
              value={this.state.name}
              error={Boolean(this.state.errors['name'])}
              helperText={this.state.errors['name']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
          <Grid item={true} xs={12} md={6} className="form-field">
            <TextField
              id="animal"
              select={true}
              label="Animal"
              value={this.state.animal}
              onChange={this.handleChangeAnimal()}
              error={Boolean(this.state.errors['animal'])}
              helperText={this.state.errors['animal']}
              fullWidth={true}
            >
              {this.state.animals.map((animal: any, key: number) => {
                return <MenuItem value={animal.id} key={key}>{animal.name}</MenuItem>;
              })}
            </TextField>
          </Grid>
          <Grid item={true} xs={12} className="form-field">
            <CKeditor name="text-editor" onBeforeLoad={this.updateCkEditor} data={this.state.description} onChange={(evt: any) => this.setState({descriptionUpdated : evt.editor.getData()})}/>
          </Grid>
          <Link to={`/Races/Images/${this.props.match.params.id}`}
              onClick={MainStore.updateActualView(`Races/Afficher/${id}`)}>
              <Button variant="raised" mini={true} color="inherit" aria-label="modifier" className="btn btn-orange">
                  Gestion des images
              </Button>
          </Link>
        </Grid>
        <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>
          {this.state.isUpdating ? "Modifier" : "Créer"}
        </Button>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/BreedProfile.tsx